export * from './lib/hosted-auth';
export * from './lib/account-profile.mapping';

export { default as InstagramIcon } from './lib/icon.svg';
export const instagramName = 'Instagram';
